<template>
  <div>
    <div class="d-flex gap-4 mb-3 flex-column">
      <label for="deficiencia">
        <b>Existem pessoas com deficiência?</b>
      </label>
      <select v-model="existemDeficiencias" required>
        <option value="nao">Não há pessoas com deficiência</option>
        <option value="sim">Sim</option>
      </select>
    </div>

    <div class="gap-3 d-flex flex-column" v-if="existemDeficiencias === 'sim'">
      <label for="deficiencia">
        <b>Selecione a Deficiência e quantidade de pessoas com cada deficiência:</b>
      </label>
      <div v-for="(item, index) in deficiencias" :key="index" class="deficiencia-item d-flex my-2 flex-column justify-content-between gap-3">
        <select v-model="item.tipo">
          <option disabled value="">Selecione uma opção</option>
          <option>Deficiência Física</option>
          <option>Síndrome de Down</option>
          <option>Mobilidade Reduzida</option>
          <option>Deficiência Intelectual</option>
          <option>Deficiência Auditiva</option>
          <option>Deficiência Visual</option>
          <option>Autismo</option>
          <option value="outros">Outros (preencher)</option>
        </select>
        <input v-if="item.tipo === 'outros'" v-model="item.descricao" placeholder="Descreva aqui" />
        <label>Quantidade:</label>
        <input type="number" min="0" v-model="item.quantidade" placeholder="Quantidade" />
      </div>
      <div class="d-flex justify-content-center gap-5">
        <button type="button" class="btn btn-danger" @click="removerDeficiencia(index)" v-if="deficiencias.length > 1">Remover</button>
        <button type="button" class="btn btn-success" @click="adicionarDeficiencia">Adicionar Deficiência</button>
      </div>
    </div>
    <div v-else>
      Não há pessoas com deficiência.
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue';
import { defineEmits } from 'vue';

const emit = defineEmits(['update:deficiencias']);

const existemDeficiencias = ref('nao');
const deficiencias = ref([]);

watch(existemDeficiencias, (newVal) => {
  if (newVal === 'sim' && deficiencias.value.length === 0) {
    adicionarDeficiencia(); // Adiciona uma deficiência inicial se mudar para "Sim" e não houver deficiências.
  } else if (newVal === 'nao') {
    deficiencias.value = []; // Limpa a lista de deficiências se mudar para "Não".
    emit('update:deficiencias', deficiencias.value);
  }
});

const adicionarDeficiencia = () => {
  deficiencias.value.push({ tipo: '', quantidade: 0, descricao: '' });
  emit('update:deficiencias', deficiencias.value);
};

const removerDeficiencia = (index) => {
  deficiencias.value.splice(index, 1);
  emit('update:deficiencias', deficiencias.value);
};

// Watcher para atualizar a descrição para "não se aplica" quando o tipo é "outros" e a descrição está vazia
watch(deficiencias, (newVal) => {
  newVal.forEach((item) => {
    if (item.tipo === 'outros' && !item.descricao) {
      item.descricao = 'não se aplica';
    }
  });
  emit('update:deficiencias', newVal);
}, { deep: true });
</script>

<style scoped>
.deficiencia-item {
  margin-bottom: 0.75rem;
  padding: 1rem;
  background: #f8fafc;
  border: 1px solid var(--catavento-border, #d9e1ea);
  border-radius: var(--catavento-radius, 8px);
}

label {
  text-align: left;
}

.btn {
  min-width: 120px;
}

@media (max-width: 767px) {
  .deficiencia-item {
    padding: 0.85rem;
  }

  .d-flex.justify-content-center {
    flex-direction: column;
    gap: 0.75rem !important;
  }

  .btn {
    width: 100%;
  }
}
</style>
